export default [{"id":"1","startTime":0,"endTime":3349,"text":"<b>This is followed by the assembly of the</b>\n<b>bottom part.</b>"}];